import z from "zod";
import { contactInfoSchema } from "../contactInfo";
export const organisationSchema = z.object({
    abn: z.string(),
    /**
     * Display form of `organisation_name` with the legal-entity suffix removed
     * ("Bloggs Construction Pty Ltd" -> "Bloggs Construction"). Derived by the
     * database, never written by a client. Optional because older API responses
     * and locally-constructed organisations do not carry it — fall back to
     * `organisation_name` when absent.
     */
    canonical_name: z.string().nullish(),
    contact_info: contactInfoSchema,
    contact_info_id: z.string(),
    created: z.date(),
    envirotrack_enabled: z.boolean().optional(),
    govassure_enabled: z.boolean().optional(),
    hammertech_enabled: z.boolean(),
    integrations: z.array(z.custom()).optional(),
    is_contractor: z.boolean().optional(),
    is_setup: z.boolean(),
    max_active_projects: z.number(),
    mfa_enabled: z.boolean().optional(),
    organisation_id: z.string(),
    organisation_logo: z.string(),
    organisation_name: z.string(),
    plan_type: z.string(),
    socialpro_enabled: z.boolean().optional(),
    stripe_id: z.string(),
    subpackage_enabled: z.boolean(),
    transient: z.boolean().optional(),
    users: z.array(z.string())
});
/**
 * Minimal organisation summary behind a collaborator avatar: the raw logo S3
 * key (the client presigns it) plus the name shown in the avatar tooltip.
 */
export const collaboratorDetailSchema = z.object({
    organisation_id: z.string(),
    organisation_logo: z.string(),
    organisation_name: z.string()
});
